module.exports = __webpack_public_path__ + "img/logo_ecshopx.acfddca1.png";